// Local canonical purchases are immutable. Every live envelope writer uses the
// same Web Lock; this guard also rejects a stale tab's later autosave.
export const stableLocalValue = value => JSON.stringify(value, (_key, item) => item && typeof item === 'object' && !Array.isArray(item)
  ? Object.fromEntries(Object.keys(item).sort().map(key => [key, item[key]])) : item);

export const localSourceSnapshot = item => {
  const result = { ...item };
  for (const key of ['previewUrl', 'previewExpiresAt', '_summaryUpdatedAt', 'originalUrl']) delete result[key];
  return result;
};

export function assertLocalPurchaseIntegrity(previous = {}, next = {}, appendPurchase = false) {
  const before = previous.purchaseDocuments || [], after = next.purchaseDocuments || [];
  if (!Array.isArray(before) || !Array.isArray(after) || after.length > 50000) throw new Error('The local purchase collection is invalid.');
  const ids = new Set(), sources = new Set();
  for (const document of after) {
    const source = next.intakeItems?.find(item => item.id === document.intakeRecordId);
    const sourceKey = stableLocalValue([document.organizationId, document.businessId, document.sourceSha256]);
    if (!document.id || ids.has(document.id) || sources.has(sourceKey) || document.revision !== 1
      || document.paidTotal !== '0.0000' || !Array.isArray(document.payments) || document.payments.length
      || !/^[a-f0-9]{64}$/.test(document.sourceSha256 || '')
      || !source || source.status !== 'Accepted' || source.purchaseDocumentId !== document.id
      || source.workspaceId !== document.organizationId || source.businessId !== document.businessId
      || source.fileHash !== document.sourceSha256 || source.originalFilename !== document.sourceFilename
      || !next.businesses?.some(business => business.id === document.businessId && business.workspaceId === document.organizationId)) {
      throw new Error('The saved purchase and its original source must stay linked, scoped, and unpaid.');
    }
    ids.add(document.id); sources.add(sourceKey);
  }
  for (const document of before) {
    const saved = after.find(item => item.id === document.id);
    const sourceBefore = previous.intakeItems?.find(item => item.id === document.intakeRecordId);
    const sourceAfter = next.intakeItems?.find(item => item.id === document.intakeRecordId);
    if (stableLocalValue(saved) !== stableLocalValue(document)
      || stableLocalValue(localSourceSnapshot(sourceBefore)) !== stableLocalValue(localSourceSnapshot(sourceAfter))) {
      throw new Error('Another view has saved this purchase. Reload before editing; the canonical purchase was not overwritten.');
    }
  }
  if (!appendPurchase && after.some(item => !before.some(old => old.id === item.id))) {
    throw new Error('Create canonical purchases with the reviewed purchase Save, not a snapshot import.');
  }
}
